import { MenuItemType } from "../constants/menu";
import { SUPPORT_MENU_ITEMS } from "../constants/supportMenu";




const supportMenuItems = () => {
    // NOTE - You can fetch from server and return here as well
    return SUPPORT_MENU_ITEMS;
};

const findAllParent = (menuItems: MenuItemType[], menuItem: MenuItemType): string[] => {
    let parents: string[] = [];
    const parent = findMenuItem(menuItems, menuItem["parentKey"]);

    if (parent) {
        parents.push(parent["key"]);
        if (parent["parentKey"]) parents = [...parents, ...findAllParent(menuItems, parent)];
    }

    return parents;
};

const findMenuItem = (
    menuItems: MenuItemType[] | undefined,
    menuItemKey: MenuItemType["key"] | undefined
): MenuItemType | null => {
    if (menuItems && menuItemKey) {
        for (var i = 0; i < menuItems.length; i++) {
            if (menuItems[i].key === menuItemKey) {
                return menuItems[i];
            }
            var found = findMenuItem(menuItems[i].children, menuItemKey);
            if (found) return found;
        }
    }
    return null;
};

export { supportMenuItems, findAllParent, findMenuItem };
